import { AppConfig } from '@porterin/component-library/src/ts-utils/analytics/fetch-config/AppConfig';

declare global {
  interface Window {
    __WEB_CONFIG__?: AppConfig;
  }
}

export const getAppConfig = (): AppConfig => {
  if (typeof window === 'undefined' || !window.__WEB_CONFIG__) {
    return {} as AppConfig;
  }
  return window.__WEB_CONFIG__;
};
